import { ISendToIntacctInvoice } from './i-sendtointacctinvoice.interface';
import { BusinessObject } from '../../../shared/business-object.model';

export class SendToIntacctInvoice extends BusinessObject implements ISendToIntacctInvoice {
	facilityId: number;
	invoiceId: number;
	invoiceNumber: string;
	invoicingParty: string;
	processDate: Date;
	invoiceDate: Date;
	invoiceReceivedDate: Date;
	billingMonth: Date;
	invoiceDueDate: Date;
	glPostingDate: Date;
	loadingIntacctData: boolean;
	accountingDueDate: Date;
	accountingInvoiceDate: Date;
	purchaseOrderPaymentStatus: string;
	purchaseOrderState: string;

  constructor(data?: any) {
		super(data);
		if (data) {
			if (data.storageLocation || data.storageLocationId) {
				this.facilityId = data.storageLocationId ? data.storageLocationId : data.storageLocation.id;
			}
			if (data.dueDate) {
				this.accountingDueDate = new Date(data.dueDate);
			}
			if (data.billingMonth) {
				this.billingMonth = new Date(data.billingMonth);
			}
			if (this.invoiceReceivedDate != null) {
				this.accountingInvoiceDate = this.invoiceReceivedDate;
			} else {
				this.accountingInvoiceDate = this.invoiceDate;
			}
		}
	}
}